var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col"},[_c('h3',{staticClass:"mb-5"},[_vm._v("7 members")]),_c('div',{staticClass:"row row-cols-1 row-cols-sm-2 row-cols-xl-3"},_vm._l((_vm.members),function(member){return _c('div',{key:`member-`+member.id,staticClass:"col mb-3 mb-lg-5"},[_c('member-card',{attrs:{"member":member}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }